import * as React from "react";
const SvgFiRrZ = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 24H5.912a3.86 3.86 0 0 1-3.723-2.698c-.537-1.64.016-3.358 1.407-4.379L19.222 5.464c.827-.606.897-1.505.688-2.144C19.7 2.682 19.113 2 18.088 2H3C1.692 1.994 1.693.005 3 0h15.088a3.86 3.86 0 0 1 3.723 2.698c.537 1.64-.016 3.358-1.407 4.379L4.778 18.536c-.827.606-.897 1.505-.688 2.144.209.638.797 1.32 1.822 1.32H21c1.308.006 1.307 1.995 0 2"
    />
  </svg>
);
export default SvgFiRrZ;
